<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Expired Business Permits</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">
    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Expired Business Permits</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Expired Permits</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <!-- Filter Header -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3" role="toolbar">
                    <label class="text-nowrap mb-0 px-2">Date From:</label>
                    <input v-model="dateFrom" class="form-control pr-3" type="date">

                    <label class="text-nowrap mb-0 px-2">Date To:</label>
                    <input v-model="dateTo" class="form-control pr-2" type="date">

                    <label class="text-nowrap mb-0 px-2">Business Activity:</label>
                    <select @change="getTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Business Activity">
                      <option value="">All</option>
                      <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                        {{ item.incomeTypeDescription }}
                      </option>
                    </select>

                    <label class="text-nowrap mb-0 mx-2">Business Sub Category:</label>
                    <select @change="selectedTradeSubCategory($event)" class="form-control bg-white" data-live-search="true" title="Select Sub Categories">
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                        {{ item.feeDescription }}
                      </option>
                    </select>

                    <select @change="selectedSubCounty($event)" class="form-control bg-white mx-2" data-live-search="true" title="Select Sub County">
                      <option value="">All Sub Counties</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                        {{ item.subCountyName }}
                      </option>
                    </select>

                    <select @change="selectedWard($event)" class="form-control bg-white" data-live-search="true" title="Select Ward">
                      <option value="">All Wards</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                        {{ item.wardName }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Search Header -->
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3 flex-grow-1" role="toolbar">
                    <form class="app-search p-0 m-0 w-100">
                      <div class="position-relative">
                        <input v-model="search" type="text" class="form-control w-100" placeholder="Search... eg Business Name, ID Number, Bill Number, etc">
                        <span class="bx bx-search-alt"></span>
                      </div>
                    </form>
                  </div>
                  <div class="pr-3">
                    <button v-if="getRight('SBP DOWNLOAD EXPIRED')" @click="downloadApplicationsPaginated()" class="btn btn-primary">Download</button>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">Bill No</th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Expiry Date</th>
                        <th>Licensing Officer</th>
                        <th>Status</th>
                        <th class="text-right" scope="col">Amount Paid</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(item, index) in businesses">
                        <td class="text-capitalize text-nowrap">
                          <a href="javascript:void(0)" @click="printBill(item.billNo)">{{item.billNo}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">{{item.businessID}}</td>
                        <td class="text-capitalize text-nowrap">
                          <a href="javascript:void(0);">{{item.businessName}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">
                          <span class="badge badge-soft-danger">{{formattedDate(item.endDate)}}</span>
                        </td>
                        <td>{{item.issuingOfficer || 'N/A'}}</td>
                        <td>
                          <span class="badge badge-soft-danger text-uppercase rounded-pill">EXPIRED</span>
                        </td>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(item.receiptAmount)}}</span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end">
                            <button @click="getBusinessDetails(item.businessID, item.billNo, item.feeID)"
                                    class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-3"
                                    data-bs-target=".receipting-modal" data-bs-toggle="modal" type="button">
                              <i class="bx bx-show font-size-16 align-middle me-2"></i>
                              View Details
                            </button>
                            <a v-if="getRight('SBP PRINT PERMIT')" @click="printTradePermitBillNo(item.billNo)"
                               class="btn btn-success btn-sm waves-effect waves-light">
                              <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                              View Permit
                            </a>
                            <div class="dropdown ms-2">
                              <a aria-haspopup="true" class="text-muted font-size-16" data-bs-toggle="dropdown" role="button">
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a @click="getBusinessDetails(item.businessID, item.billNo, item.feeID)"
                                   class="dropdown-item" data-bs-target=".receipting-modal" data-bs-toggle="modal" href="javascript:void(0);">
                                  <i class="font-size-15 mdi mdi-eye me-3"></i>View
                                </a>
                                <a @click="printBill(item.billNo)" class="dropdown-item" href="javascript:void(0);">
                                  <i class="font-size-15 mdi mdi-printer me-3"></i>Print Bill
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{businesses.length}} Certs</th>
                        <th class="text-nowrap" colspan="5"></th>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(totalAmount)}}</span>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <!-- Loading State -->
                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <p>We are fetching the expired permits for you. Please wait...</p>
                    </div>

                    <!-- No Results State -->
                    <div class="card-body d-flex flex-column justify-items-center align-items-center text-center"
                         v-if="businesses.length < 1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Expired Permits Found</h4>
                      <p>There are no expired business permits matching your search criteria.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">Rows Per Page</span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                        <option value="150">150 Rows</option>
                        <option value="200">200 Rows</option>
                      </select>
                    </div>
                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a @click="prevPage" class="page-link">Previous</a>
                      </li>
                      <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                          :class="{ active: currentPage === page }" class="page-item">
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else @click="goToPage(page)" class="page-link">{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Business Details Modal -->
      <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Business Details</h5>
              <span class="badge rounded-pill bg-danger text-uppercase font-12px text-uppercase mx-3">EXPIRED</span>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div :class="item.completed==='active' ? 'active' : ''" class="item event-list" v-for="(item, index) in statuses" :value="item" :key="index" style="display: inline-block; width: 350px">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">{{getHumanDate(item.updatedDate)}}</div>
                            <h5 class="mb-4">{{item.status}}</h5>
                          </div>
                          <div class="event-down-icon">
                            <i v-if="item.completed==='true'" class="bx bxs-check-circle h1 text-success down-arrow-icon"></i>
                            <i v-if="item.completed==='false' || item.completed==='active'" class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>
                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize"><a href="javascript: void(0);">{{item.issuingOfficer}}</a></p>
                            <p v-if="item.statusID !== '2'" class="text-muted text-capitalize mb-1"><i class="bx bx-map"></i>{{item.location}}</p>
                            <p v-if="item.completed === 'true' && item.statusID==='2'" @click="printReceipt()" class="text-muted text-capitalize mb-1">
                              <a href="javascript: void(0);"><i class="bx bx-receipt"></i> View Receipt</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-briefcase-alt-2 font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Business Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">Verification Status <br> <a href="user-details.html">({{entries.issuingOfficer}})</a></th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Name</p></td>
                            <td class="">{{businessDetails.businessName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Plot Number.</p></td>
                            <td class="">{{businessDetails.plotNumber}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">KRA Pin No.</p></td>
                            <td class="">{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">VAT No.</p></td>
                            <td class="">{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Activity</p></td>
                            <td class="">{{businessDetails.businessDes}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr v-if="businessDetails.feeID === billDetail.feeID">
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p></td>
                            <td class="">{{billDetail.feeDescription}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bxs-user-pin font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Owner Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">Verification Status <br> <a href="user-details.html">({{businessDetails.createdBy}})</a></th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Full Names</p></td>
                            <td class="">{{businessDetails.fullNames}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">ID/PPT No.</p></td>
                            <td class="">{{businessDetails.ownerID}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Email</p></td>
                            <td class="">{{businessDetails.ownerEmail}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Mobile No.</p></td>
                            <td class=""><a :href="'tel:' + businessDetails.ownerPhone">{{businessDetails.ownerPhone}}</a></td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Mobile No.</p></td>
                            <td class=""><a :href="'tel:' + businessDetails.ownerPhone">{{businessDetails.ownerPhone}}</a></td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Postal Address</p></td>
                            <td class="">{{businessDetails.postalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-phone-call pin font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Location and Contact information</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">Verification Status <br> <a href="user-details.html">({{entries.issuingOfficer}})</a></th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Mobile No.</p></td>
                            <td class=""><a :href="'tel:' + businessDetails.businessPhone">{{maskPhoneNumber(businessDetails.businessPhone)}}</a></td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Phone No</p></td>
                            <td class=""><a :href="'tel:' + businessDetails.businessPhone">{{maskPhoneNumber(businessDetails.businessPhone)}}</a></td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Email address</p></td>
                            <td class=""><a :href="'mailto:' + businessDetails.businessEmail">{{businessDetails.businessEmail}}</a></td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Sub county</p></td>
                            <td class="">{{businessDetails.subCountyName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Ward</p></td>
                            <td class="">{{businessDetails.wardName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical address/Street</p></td>
                            <td class="">{{businessDetails.physicalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Building Name</p></td>
                            <td class="">{{businessDetails.buildingName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Stall/Room No.</p></td>
                            <td class="">{{businessDetails.roomNo}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-8">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bx-map font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Map View</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div>
                        <iframe frameborder="0" scrolling="no" style="width: 100%; height: 450px;" v-bind:src="iframeSrc"></iframe>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center">
                        <i class="bx bxs-edit-alt pin font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Revenue Officer Notes ({{entries.issuingOfficer}})</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="alert alert-warning border-1 border-warning" role="alert">
                        {{entries.comments}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a v-if="getRight('SBP PRINT PERMIT')" @click="printTradePermit(businessDetails.businessID)" class="btn btn-primary waves-effect waves-light" type="button">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> View Permit
              </a>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Government</div>
            </div>
          </div>
        </div>
      </footer>

    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import router from "@/router";
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import moment from 'moment';

export default {
  name: "Expired",
  components: {ToolBar, NavigationBar},

  data() {
    return {
      loading: false,
      search: '',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      dateFrom: '',
      dateTo: '',
      businesses: [],
      businessDetails: {
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      billDetail: {
        billNo: null,
        incomeTypeDescription: null,
        feeID: null,
        feeDescription: null,
        receiptAmount: null,
        billBalance: null,
        subCountyName: null,
        wardName: null
      },
      feesAndCharges: {},
      receiptDetails: {},
      receiptInfos: [],
      statuses: [],
      entries: {
        billNo: null,
        businessID: null,
        businessName: null,
        issuingOfficer: null,
        comments: null
      },
      totalAmount: 0,
      subCounties: [],
      wards: [],
      tradeCategories: [],
      tradeSubCategories: [],
      message: ''
    };
  },

  computed: {
    iframeSrc() {
      return 'https://maps.google.com/maps?q=' + this.businessDetails.lat + ',' + this.businessDetails.lng + '&t=&z=13&ie=UTF8&iwloc=&output=embed';
    }
  },

  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.getApplicationsPaginated("");
    this.getTradeCategory();
    this.getSubCounties();
    this.menuAccess();
  },

  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getApplicationsPaginated("");
    },
    search() {
      this.getApplicationsPaginated(this.search);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    }
  },

  methods: {
    getRight(type) {
      return getRight(type);
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    formattedDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    getHumanDate(dateData) {
      if (dateData == "-") {
        return "-";
      } else {
        const dateObject = new Date(Date.parse(dateData));
        return dateObject.toDateString();
      }
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    pagination(current, total, maxVisible) {
      let pages = [];
      let start = current - Math.floor(maxVisible / 2);
      let end = current + Math.floor(maxVisible / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisible - 1;
        if (end > total) end = total;
      }
      if (end > total) {
        end = total;
        start = end - maxVisible + 1;
        if (start < 1) start = 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) pages.unshift("...");
      if (end < total) pages.push("...");
      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplicationsPaginated("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplicationsPaginated("");
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplicationsPaginated("");
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Expired Biz");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Menu access logged
          })
          .catch((e) => {
            console.error(e.message);
          });
    },

    async getApplicationsPaginated(keyword) {
      this.loading = true;
      this.businesses = [];

      try {
        const data = new FormData();
        data.append("function", "getApplicationsPaginated");
        data.append("statusID", "5");
        data.append("stageStatus", "Approved");
        data.append("expired", "true");
        data.append("search", keyword || "");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const res = await execute(data, trade);

        if (res.data.success) {
          this.businesses = res.data.data.businesses;
          this.totalItems = parseInt(res.data.data.totalItems.count);
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.totalAmount = this.businesses.reduce((sum, item) => sum + parseFloat(item.receiptAmount || 0), 0);
        } else {
          this.message = res.data.message;
        }
      } catch (error) {
        console.error("Error loading expired permits:", error);
        this.message = error.message;
      } finally {
        this.loading = false;
      }
    },

    async downloadApplicationsPaginated() {
      try {
        const data = new FormData();
        data.append("function", "downloadApplicationsPaginated");
        data.append("statusID", "5");
        data.append("stageStatus", "Approved");
        data.append("expired", "true");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const response = await executeDownload(data, trade);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `Expired_Permits_${this.dateFrom}_to_${this.dateTo}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download failed:", error);
        alert("Failed to download report. Please try again.");
      }
    },

    getBusinessDetails(businessID, billNo, feeID) {
      this.statuses = [];
      const data = new FormData();
      data.append("function", "getBusinessDetails");
      data.append("billNo", billNo);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              this.statuses = res.data.data.statuses;
              this.businessDetails = res.data.data.business;
              this.billDetail = res.data.data.bill.billDetails;
              this.feesAndCharges = res.data.data.feesAndCharge;
              this.receiptDetails = res.data.data.receipt.receiptDetails;
              this.receiptInfos = res.data.data.receipt.receiptInfos;
              this.entries = res.data.data.entries;
              this.timelineCarousel();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    timelineCarousel() {
      $("#timeline-carousel").owlCarousel({
        items: 1,
        loop: false,
        margin: 0,
        nav: true,
        navText: ["<i class='mdi mdi-chevron-left'></i>", "<i class='mdi mdi-chevron-right'></i>"],
        dots: false,
        responsive: {
          576: { items: 2 },
          768: { items: 4 }
        },
        startPosition: -1
      });
    },

    printTradePermit(businessID) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("businessID", businessID);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({ businessID: businessID });
              const routeData = this.$router.resolve({name: 'trade'});
              window.open(routeData.href, '_blank');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    printTradePermitBillNo(billNo) {
      const data = new FormData();
      data.append("function", "printTradePermit");
      data.append("billNo", billNo);

      execute(data, trade)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({ billNo: billNo });
              const routeData = this.$router.resolve({name: 'trade'});
              window.open(routeData.href, '_blank');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({ receiptNo: this.receiptDetails.receiptNo });
        const routeData = this.$router.resolve({name: 'receipt'});
        window.open(routeData.href, '_blank');
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.tradeCategories = res.data.data.incomeTypes;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getTradeSubCategory(event) {
      this.loading = true;
      this.getApplicationsPaginated(event.target.value);
      this.tradeSubCategories = [];

      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.tradeSubCategories = res.data.data.feesAndCharges;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    selectedTradeSubCategory(event) {
      const data = JSON.parse(event.target.value);
      this.getApplicationsPaginated(data.feeId);
    },

    selectedSubCounty(event) {
      const data = JSON.parse(event.target.value);
      this.getWards(data.subCountyID);
      this.getApplicationsPaginated(data.subCountyName);
    },

    selectedWard(event) {
      const data = JSON.parse(event.target.value);
      this.getApplicationsPaginated(data.wardName);
    }
  }
};
</script>

<style scoped>
</style>